import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import Button from "@mui/material/Button";
import * as React from "react";
import {useEffect, useState} from "react";
import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";
import {buttonStyles, typographyStyles} from "../HR/TableTemplate";
import {deleteJob} from "../../utilities/HrAPI";
import keycloak from "../../Keycloak";
import Modal from "@mui/material/Modal";
import Enums from "../General/Enums";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import {showSaveError, showSaveSuccessMessage} from "../toastUtils";

export const modalButtonStyleDelete = {
    '&:hover': {
        color: 'white',
        backgroundColor: '#FF6600'
    },
    float: "right",
    backgroundColor: '#FF6600',
    width: '89px',
    height: '40px',
    fontFamily: 'Poppins',
    color: '#FFFFFF',
    marginLeft: 'auto',
}

export default function TableTemplate({data, columns, clientId}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [jobId, setJobId] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [tableData, setTableData] = useState(data);
    const [filteredIds] = useState([]);

    const tableHeaderStyle = {
        backgroundColor: '#DDDFDF',
        height: '56px'
    };

    const handleOptionsClick = (e, jobID) => {
        setAnchorEl(e.currentTarget)
        setJobId(jobID)
    }

    const handleDelete = () => {
        deleteJob(jobId, keycloak.token)
            .then(() => {
                closeModal()
                showSaveSuccessMessage("Job successfully deleted")
                filteredIds.push(jobId);
                const updatedData = data.filter(item => !filteredIds.includes(item.hashedCode));
                setTableData(updatedData)
            })
            .catch((e) => {
               console.error(e)
               showSaveError("We could not delete the job position, there are still candidates linked.")
            })
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const closeModal = () => {
        setShowModal(false);
    }

    const generateLink = (id) => {
        const host = window.location.href;
        const path = window.location.pathname;
        const newPath = `/ExternalCV?jobID=${id}`;
        const link = host.replace(path, newPath);
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(link).then(() => {
                console.log('Link copied to clipboard');
            }).catch(err => {
                console.error('Error in copying link: ', err);
            });
        } else {
            const textarea = document.createElement('textarea');
            textarea.value = link;
            document.body.appendChild(textarea);
            textarea.select();
            textarea.setSelectionRange(0, 99999); // For mobile devices

            try {
                document.execCommand('copy');
            } catch (err) {
                console.error('Error in copying link: ', err);
            }
            document.body.removeChild(textarea);
        }
    }

    const openModal = () => {
        handleClose()
        setShowModal(true);
    }

    useEffect(() => {
        setTableData(data);
    }, [data]);

    function determineJobStatus(fromDate, toDate) {
        let currentDate = formatDate(new Date());

        let startDate = formatDate(fromDate);
        let endDate = formatDate(toDate);

        return (startDate <= currentDate && endDate >= currentDate) ? "Active" :  "Disabled";
    }

    function formatDate(dateString) {
        const date = new Date(dateString);
        const options = { year: 'numeric', month: '2-digit',day: '2-digit' };
        return date.toLocaleString('en-ZA', options).replace(',', '');
    }

    return (
        <div data-testid={"table-div"}>
            <Modal data-testid={"confirmDelete-modal"}
                   open={showModal}
                   aria-labelledby="modal-modal-title"
                   aria-describedby="modal-modal-description">
                <Box sx={Enums.modalStyle}>
                    <h3>
                        Delete Job
                    </h3>
                    <Grid container direction={"row"} alignItems={"flex-end"} padding={2} spacing={2}>
                        <Grid item xs={12}>
                            <body-4>
                                Are you sure you want to delete this job?
                            </body-4>
                        </Grid>
                        <Grid item xs={10}>
                            <Button variant="outlined" data-testid={"cancel"} onClick={closeModal} style={{
                                float: 'right',
                                width: '89px',
                                height: '40px',
                                fontFamily: 'Poppins',
                                color: '#FF6600',
                                borderColor: '#FF6600'
                            }}>Cancel</Button>
                        </Grid>
                        <Grid item xs={2}>
                            <Button onClick={handleDelete} data-testid={"delete"} sx={modalButtonStyleDelete}>Delete</Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
            <TableContainer className="mt-4" component={Paper}
                            sx={{borderRadius: "4px", boxShadow: "0px 0px 0px 1px #E0E0E0"}}>
                <Table>
                    <TableHead>
                        <TableRow style={tableHeaderStyle}>
                            {
                                columns.map((column) => (
                                    <TableCell sx={{fontWeight: '600'}}>
                                        {column.label}
                                    </TableCell>
                                ))
                            }
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {
                            tableData && tableData.length > 0 ? tableData.map((row, index) => (
                                <TableRow key={index} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                                    <TableCell scope="row">
                                        {row.jobTitle}
                                    </TableCell>

                                    <TableCell scope="row">
                                        {
                                            determineJobStatus(row.jobDetails.fromDate, row.jobDetails.toDate)
                                        }
                                    </TableCell>

                                    <TableCell scope="row">
                                        {row.dateModified}
                                    </TableCell>

                                    <TableCell scope="row">
                                        <Button data-testid={`options${index}`} align="left" variant="text" style={{color: 'black'}} onClick={(event) => {
                                            handleOptionsClick(event, row.hashedCode)
                                        }}>
                                            <MoreVertOutlinedIcon/>
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )) : ""
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <Popover data-testid={'popover'} open={open} anchorEl={anchorEl} onClose={handleClose}
                     anchorOrigin={{vertical: 'bottom', horizontal: 'right'}} elevation={1}>
                <Typography sx={typographyStyles}>
                    <Button href={`/JobView?jobID=${jobId}`}
                            sx={buttonStyles} data-testid={"viewJob"}>View</Button>
                </Typography>
                <Typography sx={typographyStyles} hidden={!(keycloak.hasResourceRole("system_admin") || keycloak.hasResourceRole("client_recruiter"))}>
                    <Button href={`/JobOpportunities?clientId=${clientId}`}
                            sx={buttonStyles} data-testid={"jobListing"}>Listings</Button>
                </Typography>
                <Typography sx={typographyStyles}>
                    <Button href={`/JobsEdit?jobID=${jobId}`}
                            sx={buttonStyles} data-testid={"editJob"}>Edit</Button>
                </Typography>
                <Typography sx={typographyStyles}>
                    <Button sx={buttonStyles} data-testid={"deleteJob"} onClick={openModal}>Delete</Button>
                </Typography>
                <Typography sx={typographyStyles}>
                    <Button sx={buttonStyles} data-testid={"copyJobLink"} onClick={() => {generateLink(jobId)}}>Copy Job Link</Button>
                </Typography>
            </Popover>
        </div>
    );
}